import { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const FireAlarmContext = /*#__PURE__*/createContext(undefined);
export const FireAlarmProvider = ({
  alertStyleOverrides,
  children
}) => {
  const value = useMemo(() => ({
    alertStyleOverrides
  }), [alertStyleOverrides]);
  return /*#__PURE__*/_jsx(FireAlarmContext.Provider, {
    value: value,
    children: children
  });
};

/**
 * Provides the context for the `FireAlarm` component.
 * Note: The context is only available when the `FireAlarm` component is rendered as an ancestor.
 * @returns FireAlarmContext - The context for the `FireAlarm` component.
 * @returns FireAlarmContext.alertStyleOverrides - Style overrides to be applied to the `Alert` component.
 */
export const useFireAlarmContext = () => {
  const fireAlarmContext = useContext(FireAlarmContext);
  return fireAlarmContext;
};